module.exports = __webpack_public_path__ + "static/media/28.2ac7c36c.JPG";